import type { AxiosResponse } from 'axios';
import { inject, injectable } from 'inversify';
import { ClientGameApiRoute } from '@client/entity/client-game/data/constant/client-game.api-routes';
import type { ClientGameApiData } from '@client/entity/client-game/data/api-data/client-game.api-data';
import { HostDependencyTypes } from '@shared/common/host/host.dependency-types';
import type { HubApiService } from '@shared/common/host/data/service/hub.api-service';

@injectable()
export class ClientGameApiService {
  public constructor(
    @inject(HostDependencyTypes.HubApiService)
    private readonly hubApiService: HubApiService,
  ) {}

  public getClientGames(clientId: string): Promise<AxiosResponse<ClientGameApiData[]>> {
    return this.hubApiService.get<ClientGameApiData[]>(ClientGameApiRoute.GetClientGames(clientId), {
      headers: {
        Accept: 'application/json',
      },
    });
  }
}
